import ArtworkCard from './ArtworkCard'

export default function GalleryGrid({ artworks, onArtworkClick }) {
  if (artworks.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="text-xl text-neutral-500">Keine Werke in dieser Kategorie gefunden.</p>
      </div>
    )
  }

  return (
    <>
      {/* Artwork Count */}
      <div className="mb-6 text-center">
        <p className="text-neutral-600">
          {artworks.length} {artworks.length === 1 ? 'Werk' : 'Werke'}
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {artworks.map(artwork => (
          <ArtworkCard
            key={artwork.id}
            artwork={artwork}
            onClick={() => onArtworkClick(artwork)}
          />
        ))}
      </div>
    </>
  )
}
